import { useState } from "react";
import { api, parseApiError } from "../lib/api";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import ErrorMessage from "./ErrorMessage";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState(null);

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null); setOk(false);
    try {
      await api.post("/inquiries", form);
      setOk(true);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (e) {
      setErr(parseApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="aq-section aq-bg-foam-deep">
      <div className="aq-container grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="aq-overline">Inquire</span>
          <h2 className="aq-h2 text-4xl sm:text-5xl mt-4" style={{ color: "var(--aq-navy)" }}>
            Custom dates? Group trip?
          </h2>
          <span className="aq-divider" />
          <p className="text-base text-[15px] leading-relaxed" style={{ color: "var(--aq-text-soft)" }}>
            Tell us what you have in mind. The captain reads everything personally and
            usually replies within 24 hours. For instant confirmation, use the trips section
            above.
          </p>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 grid gap-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <label className="block">
              <span className="text-xs font-medium uppercase tracking-wider" style={{ color: "var(--aq-text-soft)" }}>Name</span>
              <input data-testid="contact-name" required value={form.name} onChange={upd("name")} className="aq-input mt-1" />
            </label>
            <label className="block">
              <span className="text-xs font-medium uppercase tracking-wider" style={{ color: "var(--aq-text-soft)" }}>Email</span>
              <input type="email" data-testid="contact-email" required value={form.email} onChange={upd("email")} className="aq-input mt-1" />
            </label>
          </div>
          <label className="block">
            <span className="text-xs font-medium uppercase tracking-wider" style={{ color: "var(--aq-text-soft)" }}>Phone (optional)</span>
            <input data-testid="contact-phone" value={form.phone} onChange={upd("phone")} className="aq-input mt-1" />
          </label>
          <label className="block">
            <span className="text-xs font-medium uppercase tracking-wider" style={{ color: "var(--aq-text-soft)" }}>Message</span>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={upd("message")} className="aq-input mt-1" />
          </label>
          <button type="submit" disabled={busy} data-testid="contact-submit" className="aq-btn-primary justify-self-start">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Mail size={16} />}
            {busy ? "Sending…" : "Send Inquiry"}
          </button>
          {ok && (
            <div className="flex items-center gap-2 text-sm" data-testid="contact-success" style={{ color: "var(--aq-navy)" }}>
              <CheckCircle2 size={18} style={{ color: "var(--aq-gold)" }} />
              Thanks — the captain will be in touch shortly.
            </div>
          )}
          {err && <ErrorMessage testid="contact-error" message={err} />}
        </form>
      </div>
    </section>
  );
}
